import React from 'react';
import socialStyles from './social.module.sass';
import FacebookLogo from './icons/FacebookLogo';
import InstagramLogo from './icons/InstagramLogo';
import EmailSVG from './icons/EmailSVG';

export default props => {
  const { addClass } = props
  return (
    <ul className={[socialStyles.social, addClass].join(' ')}>
      <li className={socialStyles.link}><a href="//eepurl.com/gksg-f" title="Subscribe to the Truffle Pigs newsletter"><EmailSVG /></a></li>
      <li className={socialStyles.link}><a href="//facebook.com/TrufflePigs" title="Follow Truffle Pigs on Facebook"><FacebookLogo /></a></li>
      <li className={socialStyles.link}><a href="//instagram.com/trufflepigsfieldbc" title="Follow Truffle Pigs on Instagram"><InstagramLogo /></a></li>
    </ul>
  );
};